<template>
  <v-container>
    <PageHeader no-padding />
    <Subheader v-model="search" title="File Schemas" search="file schemas">
      <v-dialog v-model="addFormDialog" width="500" persistent>
        <template v-slot:activator="{ on }">
          <v-btn dark color="add" v-on="on">
            <v-icon class="mr-1">add</v-icon>
            {{ $t('DatasetMetadataSchemaManage.addTitleMsg') }}
          </v-btn>
        </template>
        <DatasetMetadataSchemaAddForm @close="addFormDialog=false" />
      </v-dialog>
    </Subheader>

    <v-card>
      <v-card-text>
        <v-data-table :loading="isLoading" :headers="headers" :pagination.sync="pagination" :items="metadataSchemaData" :search="search">
          <template v-slot:items="props">
            <td>{{ props.item.Name }}</td>
            <td class="text-xs-right">
              <v-btn small color="warning" :to="{ name: 'schemadetail', params: { id: `${props.item.Id}`}}">
                <v-icon class="mr-1">edit</v-icon>
                {{ $t('Button.Edit') }}
              </v-btn>
              |
              <v-btn :disabled="props.item.Name == 'Generic'" small color="error" @click="clickRemove(props.item)">
                <v-icon class="mr-1">delete</v-icon>
                {{ $t('Button.Delete') }}
              </v-btn>
            </td>            
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
    <AppModal v-model="dialog" max-width="800">
      <template v-slot:title>{{ deleteDialogTitle }}</template>
      <template v-slot:text>{{ deleteDialogText }}</template>
      <template v-slot:actions>
        <v-spacer></v-spacer>
        <v-btn color="delete" dark @click="agreeDelete()">
          <v-icon>delete_forever</v-icon>{{ $t('Button.Remove') }}
        </v-btn>
        <v-btn color="secondary" @click="dialog = false" outline>{{ $t('Button.Cancel') }}</v-btn>
      </template>
    </AppModal>
    <ErrorDialog v-model="errorDialog.show" :data="errorDialog.data" :title="errorDialog.title"></ErrorDialog>
  </v-container>
</template>

<script>
  import ErrorDialog from '@/components/generic/ErrorDialog'
  import DatasetMetadataSchemaAddForm from './DatasetMetadataSchemaAddForm'

  import {
    createNamespacedHelpers,
  } from 'vuex'
  const app = createNamespacedHelpers('app')
  const rawdatarepository = createNamespacedHelpers('rawdatarepository')

  export default {
    components: {
      DatasetMetadataSchemaAddForm,
      ErrorDialog,
    },
    data() {
      return {
        search: '',
        dialog: false,        
        schemaToDelete: null,
        deleteDialogTitle: 'Delete file metadata schema',
        deleteDialogText: 'Are you sure you want to delete this file metadata schema? This action cannot be undone.',
        pagination: {
          rowsPerPage: -1,
        },
        headers: [{
          text: 'Name',
          align: 'left',
          value: 'Name',
        },
        {
          align: 'left',
          value: null,
          sortable: false,
        },
        ],
        addFormDialog: false,
      }
    },
    computed: {
      ...rawdatarepository.mapGetters(['metadataSchemas']),
      metadataSchemaData() {
        return this.metadataSchemas.data
      },
      isLoading() {
        return this.metadataSchemas.isLoading
      },
      errorDialog() {
        return this.$store.getters['app/errorDialog']
      },
    },
    methods: {
      ...app.mapActions(['setSnackbar']),
      ...rawdatarepository.mapActions(['getMetadataSchemas', 'addSchema', 'deleteSchema']),
      fetchMetadataSchemas({
        forced,
      }) {
        let options = {
          successCb: () => null,
          failedCb: (err) => {
            console.error('failed getting metadata schemas ', err),
              this.$store.dispatch('app/setErrorDialog', {
                data: err.response.data,
                title: err.message,
                show: true,
              })
          },
          forced: forced || false,
        }
        this.getMetadataSchemas(options)
      },
      clickRemove(data) {
        this.deleteDialogText = `Are you sure you want to delete the file metadata schema "${data.Name}"? This action cannot be undone. If there are any files using this schema, it would be assigned to Generic file schema.`
        this.schemaToDelete = data
        this.dialog = true
      },
      agreeDelete() {
        var data = this.schemaToDelete
        var that = this
        
        let options = {
          schemaId: data.Id,
          payload: data,
          isTestRun: false,
          successCb: () => {
            that.setSnackbar({
              color: 'success',
              text: `Schema ${
              data.Name
              } removed successfully`,
            })
            that.fetchMetadataSchemas({
              forced: true,
            })
            that.$router.push('/manage/file-schemas')
            that.dialog = false
          },
          failedCb: err => console.error(err),
        }
        // this.setSnackbar({
        //   color: 'info',
        //   message: 'The schema is removed from the system.',
        // })
        this.deleteSchema(options)
        
      },
    },
    mounted() {
      this.fetchMetadataSchemas({})
    },
  }
</script>

<style lang="stylus" scoped></style>
